import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import caratulapor from '../media/Alámbricoift.pdf';

const TermsAndConditions = props =>
{
    return (
        <div id='terms-and-conditions' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4>TÉRMINOS Y CONDICIONES</h4>

                <p><span>T&eacute;rminos y Condiciones ON Al&aacute;mbrico con Telefon&iacute;a Fija</span></p>

<p><span>SERVICIO INTERNET ON AL&Aacute;MBRICO + TELEFON&Iacute;A FIJA.</span></p>
<p><span>1. Servicio de internet mediante xDSL (cable) o FTTPH (fibra), a trav&eacute;s de un equipo terminal (m&oacute;dem), mismo que puede otorgarse en comodato y/o arrendamiento, el cual no cuenta con un l&iacute;mite de capacidad; la velocidad de navegaci&oacute;n ser&aacute; con base al paquete contratado.</span></p>
<p><span>2. La velocidad puede variar dependiendo de la distancia a la que se encuentre el dispositivo del m&oacute;dem, los dispositivos conectados de manera simult&aacute;nea, las interferencias por tel&eacute;fonos y otras se&ntilde;ales de Wi-Fi cercana. Los materiales de construcci&oacute;n de una casa influyen en la se&ntilde;al de recepci&oacute;n, ya que dependiendo el material es mayor o menor la intensidad de la se&ntilde;al.</span></p>
<p><span>3. El Suscriptor podr&aacute; conectar sus dispositivos a Internet a trav&eacute;s de WIFI o mediante cable de red (Ethernet).</span></p>
<p><span>4. El equipo terminal deber&aacute; ser instalado en el domicilio del Suscriptor en un plazo m&aacute;ximo de 10 d&iacute;as h&aacute;biles.</span></p>
<p><span>5. El servicio de telefon&iacute;a fija consiste en la comunicaci&oacute;n de voz entre usuarios a trav&eacute;s de l&iacute;neas telef&oacute;nicas, conectadas a una central de conmutaci&oacute;n autom&aacute;tica, en donde no intervienen operadoras, misma que se compone de lo siguiente:&nbsp;</span></p>

<ul>
    <li><span 
        
        >DIT (Dispositivo de Interconexi&oacute;n Telef&oacute;nica).</span></li>
    <li><span 
        
        >L&iacute;nea telef&oacute;nica: Cable f&iacute;sico que se conecta a un aparato telef&oacute;nico propiedad del Suscriptor a la Red de telecomunicaciones y est&aacute; ligado a un n&uacute;mero de tel&eacute;fono &uacute;nico, asociado a el Suscriptor para poder proporcionar y por ende facturar el servicio prestado. &nbsp;</span></li>
</ul>

<p><span>6. Para hacer uso de la telefon&iacute;a fija, el Suscriptor deber&aacute; tener un aparato telef&oacute;nico de su propiedad, mismo que deber&aacute; encontrarse debidamente homologado de conformidad con las disposiciones del IFT.</span></p>
<p><span>7. Los servicios de larga distancia permiten comuniaci&oacute;n de voz entre 2 o m&aacute;s localidades diferentes y pueden ser:&nbsp;</span></p>
<ul 
>
    <li><strong><u><span 
        
        >Internacionales</span></u></strong><u><span 
        
        >:</span></u><span 
    
    >&nbsp;Consiste en el cobro de tarifas por minuto o fracci&oacute;n aplicable a todas las comunicaciones de larga distancia de o hacia puntos de los Estados Unidos o Canad&aacute; seg&uacute;n la modalidad contratada.</span></li>
    <li><strong><u><span 
        
        >Mundial</span></u></strong><u><span 
        
        >:</span></u><span 
    
    >&nbsp;Consiste en el cobro de tarifas a llamadas realizadas a nivel mundial de manera autom&aacute;tica hacia los pa&iacute;ses localizados en las siguientes regiones del mundo: (1) Sudam&eacute;rica, Caribe y Alaska, (2) Europa, &Aacute;frica, Cuenca del Mediterr&aacute;neo, (3) Centro Am&eacute;rica, y (4) Resto del mundo, Israel y Haw&aacute;i seg&uacute;n la modalidad contratada.</span></li>
</ul>
<p><span>Los pa&iacute;ses inclu&iacute;dos en el servicio contratado de los paquetes de &nbsp;Internet 20 + 1 l&iacute;nea telef&oacute;nica, Internet 30 + 1 l&iacute;nea telef&oacute;nica e Internet 40 + 1 l&iacute;nea telef&oacute;nica son los siguientes:&nbsp;</span></p>


<p><span>Anexo de destinos incluídos:</span></p>
<table  className='table table-striped table-bordered' >


    <thead className='thead-dark'>
        <tr>
            <th>
                <p><span>PAÍS</span></p>
            </th>
            <th>
                <p><span>CÓDIGOS EXCLUIDOS</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td>
                <p><span>Alemania</span></p>
            </td>
            <td>
                <p><span>49180</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Argentina</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Austria</span></p>
            </td>
            <td>
                <p><span>43711, 43720, 43730,43740,43780, 43810,43820</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Bahamas</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
           
        </tr>
        <tr>
            <td>
                <p><span>Bélgica</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
           
        </tr>
        <tr>
            <td>
                <p><span>Belice</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Bolivia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Brasil</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Bulgaria</span></p>
            </td>
            <td>
                <p><span>35948, 35987, 35998, 35999</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Chile</span></p>
            </td>
            <td>
                <p><span>563, 564, 565, 566, 567, 5621, 5622, 5625, 5627, 5628, 5629, 5667, 56322</span></p>
            </td>
            
        </tr>

        <tr>
            <td>
                <p><span>Colombia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Costa Rica</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Dinamarca</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Ecuador</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>El Salvador</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Eslovaquia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>España</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Finlandia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Francia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Grecia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Guatemala</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Haití</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Holanda</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Honduras</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Hungría</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
    </tbody>
</table>

<table  className='table table-striped table-bordered' >

    <thead className='thead-dark'>
        <tr>
            <th>
                <p><span>PAÍS</span></p>
            </th>
            <th>
                <p><span>CÓDIGOS EXCLUIDOS</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td>
                <p><span>Irlanda</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Islas Caimán</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Italia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Jamaica</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
           
        </tr>
        <tr>
            <td>
                <p><span>Luxemburgo</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
           
        </tr>
        <tr>
            <td>
                <p><span>Montenegro</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Nicaragua</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Noruega</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Panamá</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Paraguay</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>

        <tr>
            <td>
                <p><span>Perú</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Polonia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Portugal</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Principado de Liechtestein</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Reino Unido</span></p>
            </td>
            <td>
                <p><span>4470</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>República Checa</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>República de Albania</span></p>
            </td>
            <td>
                <p><span>3554</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Rumania</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Rusia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Suecia</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Suiza</span></p>
            </td>
            <td>
                <p><span>4174, 4177</span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Trinidad y Tobago</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Turquía</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Uruguay</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
        <tr>
            <td>
                <p><span>Venezuela</span></p>
            </td>
            <td>
                <p><span></span></p>
            </td>
            
        </tr>
    </tbody>
</table>
<p><span>Para los paquetes de Internet 150 + hasta 2 l&iacute;neas telef&oacute;nicas e Internet 200 megas + hasta 3 l&iacute;neas telef&oacute;nicas:</span></p>
<ul 
>
    <li><span 
        
        >Incluye a todos los pa&iacute;ses del mundo con excepci&oacute;n de Cuba, Servicios Especiales (audio texto y satelitales), Islas de &Aacute;frica y Ocean&iacute;a</span></li>
    <li><span >No aplica tampoco para &Aacute;frica y Ocean&iacute;a en:</span></li>
</ul>
<table  className='table table-striped table-bordered'>
    <thead className='thead-dark'>
        <tr>
            <th colspan="3">
                <p><span>DESTINOS NO INCLU&Iacute;DOS</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td>
                <p><span>Cape verde&nbsp;</span></p>
            </td>
            <td>
                <p><span>Fiji</span></p>
            </td>
            <td>
                <p><span>Palau</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Equatorial Guinea (Isla Bioko)</span></p>
            </td>
            <td>
                <p><span>French Polynesia (Tahiti)</span></p>
            </td>
            <td>
                <p><span>Papua New Guinea</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Madagascar</span></p>
            </td>
            <td>
                <p><span>Guam</span></p>
            </td>
            <td>
                <p><span>Solomon</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Sao Tome</span></p>
            </td>
            <td>
                <p><span>Kiribati</span></p>
            </td>
            <td>
                <p><span>Tokelau</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Tanzania (Islas Zanzibar, Pembar)</span></p>
            </td>
            <td>
                <p><span>Marshall Islands</span></p>
            </td>
            <td>
                <p><span>Tonga</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Yemen Republic (Asia)</span></p>
            </td>
            <td>
                <p><span>Micronesia</span></p>
            </td>
            <td>
                <p><span>Tuvalu</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Seychelles</span></p>
            </td>
            <td>
                <p><span>Nauru</span></p>
            </td>
            <td>
                <p><span>Vanuatu</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Comoros</span></p>
            </td>
            <td>
                <p><span>New Caledonia</span></p>
            </td>
            <td>
                <p><span>Wallis Fotuna Island</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Antartica (Australian territory)</span></p>
            </td>
            <td>
                <p><span>Niue Island</span></p>
            </td>
            <td>
                <p><span>Western Samoa</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Cook Islands</span></p>
            </td>
            <td>
                <p><span>Northern Mariana (Saipan)</span></p>
            </td>
            <td>
                <p><span>Easter Island (Isla de Pascua)</span></p>
            </td>
        </tr>
    </tbody>
</table>

<p><span>Para el paquete de Internet 150 + Hasta 2 l&iacute;neas telef&oacute;nicas, los destinos que no participan en minutos ilimitados de Larga Distancia son:&nbsp;</span></p>
<table  className='table table-striped table-bordered'>
       <thead className='thead-dark'>
        <tr>
           <th colspan="5">
                <p><span>DESTINOS QUE NO PARTICIPAN EN MINUTOS ILIMITADOS A LARGA DISTANCIA &nbsp;PARA EL PAQUETE DE INTERNET 150 + HASTA 2 L&Iacute;NEAS TELEF&Oacute;NICAS</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td>
                <p><span>AM&Eacute;RICA</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td>
                <p><span>ASIA</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Cuba</span></p>
            </td>
            <td><br/></td>
            <td><br/></td>
            <td><br/></td>
            <td>
                <p><span>Yemen</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td><br/></td>
            <td><br/></td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>&Aacute;FRICA</span></p>
            </td>
            <td><br/></td>
            <td><br/></td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Bioko</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Madagascar</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Zanzibar y Pemba</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Cabo Verde</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Santo Tom&eacute; y Pr&iacute;ncipe</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Comoras</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Seychelle</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td><br/></td>
            <td><br/></td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>OCEAN&Iacute;A</span></p>
            </td>
            <td><br/></td>
            <td><br/></td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Fiji</span></p>
            </td>
            <td><br/></td>
            <th colspan="2">
                <p><span>Micronesia (Estados Federados)</span></p>
            </th>
            <td>
                <p><span>Territorio Australiano de la Ant&aacute;rtida</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Guam</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Nauru</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Tokelau</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Isla de Pascua</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Niue</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Tonga</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Islas Cook</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Nueva Caledonia</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Tuvalu</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Islas Marianas del Norte</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Palaos</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Vanuatu</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Islas Marshall</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Pap&uacute;a Nueva Guinea</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Wallis y Futuna</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Islas Salom&oacute;n</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>Polinesia Francesa</span></p>
            </td>
            <td><br/></td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Kiribati</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td>
                <p><span>Samoa</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
            <td>
                <p><span>&nbsp;</span></p>
            </td>
        </tr>
    </tbody>
</table>

<p><span> 
8</span><span><span 
>.<span 
>&nbsp;<span 
>PORTABILIDAD.- <span 
>&nbsp;<span 
>Si el<span 
>&nbsp;Sucriptor <span 
>as&iacute;<span 
>&nbsp;lo <span 
>desea <span 
>podr&aacute; <span 
>portar su n&uacute;mero telef&oacute;nico hacia otra<span 
>&nbsp;compa&ntilde;&iacute;a. Aplicar&aacute; a <span 
>partir de la fecha en que se <span 
>solicite<span 
>&nbsp;<span 
>la porta<span 
>b<span 
>ilidad del n&uacute;mero<span 
>,<span 
>&nbsp;sin necesidad de requisitos adicionales, se dar&aacute; por terminado <span 
>el servicio auto<span 
>m&aacute;ticamente as&iacute; como la relaci&oacute;n contractual de telefon&iacute;a fija.&nbsp;</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></p>
<p><span>9. CANCELACI&Oacute;N.- Si el Suscriptor desea &nbsp;dar por terminado su &nbsp;contrato, podr&aacute; realizarlo llamando al Centro de Atenci&oacute;n a Clientes, &nbsp;para solicitar la cancelaci&oacute;n deber&aacute; estar al corriente en sus pagos y deber&aacute; &nbsp;de haber liquidado el costo de los gastos de instalaci&oacute;n en los que el proveedor incurre para brindar el servicio, en el supuesto de que los mismos hayan sido diferidos.</span></p>
<p><span>&nbsp;Para concluir el contrato, deber&aacute; entregar a Cofresa el equipo terminal otorgado para el uso del servicio de internet o de lo contrario pagar el monto del mismo, de acuerdo al tipo de servicio que se proporcion&oacute;, dicho costo se encuentra en el apartado de costos por componentes dentro del sitio de oninternet.com.mx</span></p>
<p><span>&nbsp;</span></p>
<p><span>T&Eacute;RMINOS Y CONDICIONES DE LA PROMOCI&Oacute;N PAGA MENOS POR LOS PRIMEROS 3 MESES</span></p>
<p><span>&nbsp;</span></p>
<p><span>Precios de los paquetes se&ntilde;alados son informativos, Importes en moneda nacional e impuestos incluidos, sujetos a cambio previa autorizaci&oacute;n de la Autoridad competente. El beneficio de&nbsp;pagar la mensualidad a un precio preferencial menor durante los primeros 3 meses,&nbsp;solo es aplicable si mantiene sus pagos puntuales y al corriente, a partir del 4 mes se reanudará en autom&aacute;tico el importe total de su mensualidad a pagar, de acuerdo con el paquete contratado. El servicio est&aacute; sujeto a disponibilidad de cobertura, condiciones y facilidades t&eacute;cnicas que pueden afectar la velocidad de navegaci&oacute;n del servicio. La informaci&oacute;n presentada (im&aacute;genes, textos, logos y cualquier otro elemento) constituye derechos de autor y propiedad intelectual usada con autorizaci&oacute;n de su titular, protegidos por leyes aplicables. Vigencia de la promoci&oacute;n y sus costos:&nbsp;31 de diciembre de 2021.</span></p>

<p><span>&nbsp;</span></p>
<p><span>&nbsp;</span></p>
<p><span>TARIFAS Y PRECIOS DE SERVICIOS.</span></p>
<table  className='table table-striped table-bordered'>
    <thead className='thead-dark'>
        <tr>
            <th colspan="2">
                <p><span>GASTOS DE INSTALACI&Oacute;N $800</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
      
        <tr>
            <td>
                <p><span>PAQUETE</span></p>
            </td>
            <td>
                <p><span>MENSUALIDAD</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 20 + 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$389</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 30 &nbsp;+ 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$435</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 40 + 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$499</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 150 + hasta 2 l&iacute;neas telef&oacute;nicas</span></p>
            </td>
            <td>
                <p><span>$599</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 200 + hasta 3 l&iacute;neas telef&oacute;nicas</span></p>
            </td>
            <td>
                <p><span>$999</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $435&nbsp;</span></p>
            </td>
            <td>
                <p><span>$389</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $499</span></p>
            </td>
            <td>
                <p><span>$435</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $599</span></p>
            </td>
            <td>
                <p><span>$499</span></p>
            </td>
        </tr>
    </tbody>
</table>
<p><span>Tarifas incluyen IVA</span></p>
<table  className='table table-striped table-bordered'>
    <thead className='thead-dark'>
        <tr>
             <th colspan="2">
                <p><span>Precios aplicables en zona fronteriza*</span></p>
            </th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td colspan="2">
                <p><span>GASTOS DE INSTALACI&Oacute;N $800</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>PAQUETE&nbsp;</span></p>
            </td>
            <td>
                <p><span>MENSUALIDAD</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 20 + 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$365</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 30 &nbsp;+ 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$405</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 40 + 1 l&iacute;nea telef&oacute;nica</span></p>
            </td>
            <td>
                <p><span>$465</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 150 + hasta 2 l&iacute;neas telef&oacute;nicas</span></p>
            </td>
            <td>
                <p><span>$559</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Internet 200 + hasta 3 l&iacute;neas telef&oacute;nicas</span></p>
            </td>
            <td>
                <p><span>$935</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $405&nbsp;</span></p>
            </td>
            <td>
                <p><span>$365</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $465</span></p>
            </td>
            <td>
                <p><span>$405</span></p>
            </td>
        </tr>
        <tr>
            <td>
                <p><span>Promoci&oacute;n paga menos por 3 meses en paquete $559</span></p>
            </td>
            <td>
                <p><span>$465</span></p>
            </td>
        </tr>
    </tbody>
</table>
<p><span>Tarifas incluyen IVA</span></p>
<p><span>*Consulta&nbsp;</span><span 
><a href="https://oninternet.com.mx/preciosfronterizos" target="_blank"><strong>
    <span>aqu&iacute;</span></strong></a></span><span>&nbsp;los Estados y municipios que est&aacute;n considerados como Zona fronteriza. Sujeto a disponibilidad de facilidades.&nbsp;</span></p>
<p><span>La velocidad contratada estar&aacute; comprendida entre la unidad terminal de datos entregada a EL SUSCRIPTOR y hasta el primer punto de acceso a la red de EL PROVEEDOR, conforme a las velocidades registradas ante el IFT. EL SUSCRIPTOR acepta y reconoce que la velocidad contratada puede variar durante el d&iacute;a, dependiendo de sus h&aacute;bitos de consulta de informaci&oacute;n en la red de Internet, el n&uacute;mero de equipos conectados de manera simultanea a la red, los servicios donde consulta informaci&oacute;n y la capacidad de transmisi&oacute;n de los mismos. La velocidad contratada por EL SUSCRIPTOR puede ser mermada debido a que la informaci&oacute;n viaja por medios f&iacute;sicos expuestos a factores de temperatura, humedad, clima, calidad de instalaci&oacute;n interior de EL SUSCRIPTOR, y que es responsabilidad de est&eacute;. EL PROVEEDOR prestara EL SERVICIO de acuerdo a los par&aacute;metros que establezca el IFT. EL SUSCRIPTOR est&aacute; consiente y acepta que la velocidad puede ser afectada dependiendo de la localizaci&oacute;n de su domicilio.</span></p>
<p><span>Los gastos de instalaci&oacute;n pueden ser pagados en una sola exhibici&oacute;n al momento de la contrataci&oacute;n o diferirlo en meses con cargo a su estado de cuenta, de acuerdo a la oferta promocional publicada y ajust&aacute;ndose a la&nbsp;</span></p>
<p><span>COBERTURA</span></p>
<p><span>Toda contrataci&oacute;n deber&aacute; estar dentro de la zona de cobertura, cualquier solicitud que se encuentre fuera de &eacute;sta no podr&aacute; ser procesada. En caso de que existan restricciones que impidan la instalaci&oacute;n, incluso dentro de la zona de cobertura se determinar&aacute; como imposibilidad t&eacute;cnica (IT) y le ser&aacute; notificado oportunamente al Suscriptor.</span></p>
<p><span>REQUISITOS DE CONTRATACI&Oacute;N</span></p>
<p><span>&bull; <u>Identificaci&oacute;n oficial vigente: INE</u>, Pasaporte o C&eacute;dula Profesional (aplica para personas f&iacute;sicas). Acta Constitutiva, Identificaci&oacute;n y Poder Notarial (en caso de persona moral).</span></p>
<p><span>&bull; <u>Comprobante de domicilio:</u> Recibo de luz, predial, recibo telef&oacute;nico, recibo de agua.</span></p>
<p><span>&bull; <u>&nbsp;Solicitud de servicios y/o Car&aacute;tula (debidamente firmado):</u> Completar con las firmas del Suscriptor y sin datos faltantes.</span></p>
<p><span>&bull; <u>Para el registro de tarjeta con cargo recurrente:&nbsp;</u>Se deber&aacute; especificar dentro de la <u>Solicitud de servicios y/o Car&aacute;tula &nbsp;</u>y el Suscriptor debe firmar de aceptaci&oacute;n el apartado de cargo recurrente.</span></p>
<p><span>&bull; <u>Gastos de Instalaci&oacute;n:</u> Se podr&aacute; pagar en su totalidad previo a la instalaci&oacute;n en efectivo o con tarjeta de cr&eacute;dito o d&eacute;bito o diferido a meses con cargo a su estado de cuenta.</span></p>
<p><span>En caso de haber adquirido una promoci&oacute;n de descuento en la contrataci&oacute;n del servicio, este monto se descontar&aacute; del total a pagar en la instalaci&oacute;n.</span></p>
<p><span>&nbsp;En caso de haber adquirido una promoci&oacute;n de pago diferido, el monto correspondiente se ver&aacute; reflejado en los estados de cuenta posteriores para pago del Suscriptor.</span></p>
<p><span>ESTADO DE CUENTA</span></p>
<p><span>Las rentas de los planes residenciales cuentan con una fecha l&iacute;mite de pago, misma que corresponde al precio de lista por el o los servicios contratados, en caso de que no se realice dentro de la fecha establecida, se aplicar&aacute; un gasto de cobranza y/o gasto de reconexi&oacute;n respectivamente en el siguiente estado de cuenta del cliente, importes que puede consultar en oninternet.com.mx</span></p>
<p><span>El estado de cuenta mes con mes se podr&aacute; consultar al inciar sesi&oacute;n en el Portal ON en oninternet.com.mx. Si el Suscriptor lo desea, se le enviar&aacute; a la direcci&oacute;n de correo electr&oacute;nico que se indic&oacute; al momento de la contrataci&oacute;n del servicio. El cobro de las rentas de los paquetes y servicios adicionales se pagan a mes vencido.</span></p>
<p><span>OPCIONES DE PAGO</span></p>
<p><span>&bull; Con cargo recurrente a tu tarjeta de cr&eacute;dito/d&eacute;bito llamando al n&uacute;mero de Atenci&oacute;n a Clientes al (55) 56 10 10 10</span></p>
<p><span>&bull; Con cargo en l&iacute;nea, a tarjeta de cr&eacute;dito/d&eacute;bito llamando al n&uacute;mero de Atenci&oacute;n a Clientes (55) 56 10 10 10</span></p>
<p><span>&bull; En efectivo en los centros de pago designados por Cofresa, mismos que pueden ser consultados dentro del portal en la siguiente liga: https://oninternet.com.mx/places-of-payment</span></p>
<p><span>CONTRACARGOS O CARGOS NO RECONOCIDOS EN SU TARJETA*</span></p>
<p><span>En caso de que a Cofresa le sea notificado por parte del Banco emisor en m&aacute;s de dos ocasiones que la tarjeta de cr&eacute;dito y/o d&eacute;bito que proporcion&oacute; para realizar el pago de los Servicios ha sido reportada con un contracargo o reclamo de cargo no reconocido, Cofresa tendr&aacute; la facultad de no aceptar este m&eacute;todo de pago, debiendo el Suscriptor de realizar todos los pagos de los servicios mediante una v&iacute;a alterna. Lo anterior tambi&eacute;n aplicar&aacute; cuando Cofresa detecte, en m&aacute;s de dos ocasiones, contracargos o reclamos de cargos no reconocidos en una misma cuenta que intenta ser pagada con diferentes tarjetas de cr&eacute;dito y/o d&eacute;bito. El servicio prestado por Cofresa no ser&aacute; reactivado hasta que se cubra el pago total del saldo total de la cuenta.</span></p>
<p><span>POL&Iacute;TICA DE USO JUSTO PARA INTERNET</span></p>
<p><span>Al utilizar los servicios de transmisi&oacute;n de datos de Cofresa, el Suscriptor acepta y est&aacute; de acuerdo en cumplir los t&eacute;rminos de esta pol&iacute;tica. El Servicio de Cofresa, es comercializado para el uso estrictamente personal de Internet y no puede ser utilizado con prop&oacute;sitos comerciales.</span></p>
<p><span>Queda prohibido el cobro a terceros por el uso del servicio que el Suscriptor est&aacute; contratando. As&iacute; mismo, acepta que no podr&aacute; operar o permitir que terceros operen servidores de cualquier tipo y/o conectar dispositivos, hardware o software que brinden la funcionalidad de servidor a trav&eacute;s del servicio de Cofresa. En todo momento el Suscriptor ser&aacute; responsable del buen uso de la red y se compromete a utilizar el servicio de red de acuerdo con los t&eacute;rminos y condiciones establecidos en el contrato de prestaci&oacute;n de servicios conforme con el contratado. El Suscriptor se compromete a que las actividades que realice en el uso del servicio de Internet no limitar&aacute;n, bloquear&aacute;n o de cualquier forma afectar&aacute;n la red. En caso de que Cofresa detecte que el servicio que el Suscriptor contrat&oacute; infringe cualquiera de las pol&iacute;ticas antes descritas, podr&aacute; cancelarle y/o suspenderle el servicio y cobrar los gastos adicionales que su actividad genere.</span></p>
<p><span>La informaci&oacute;n aqu&iacute; descrita o en la p&aacute;gina de internet es informaci&oacute;n exclusiva de Comercializadora de Frecuencias Satelitales S. de R.L. de C.V., y/o sus socios comerciales para promoci&oacute;n de sus servicios. Derechos reservados. El material incluyendo im&aacute;genes, textos logos y cualquier otro elemento constituyen derechos de autor y propiedad intelectual usada bajo autorizaci&oacute;n, protegidos por leyes mexicanas e internacionales.</span></p>
<p><span>&nbsp;</span></p>





            </TocPage>
        </div>
    );
}

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/components/TermsAndConditiontelfija.js